import React from 'react';
  
  const Subscription_Details = ({
    isMobile,
  }) =>  {
    return (
      <div style={{padding: '1.5rem', background: 'rgb(39,39,42,.3)', border: '1px solid rgb(39,39,42)', borderRadius: '.75rem'}}>
        <h2 style={{color: 'rgb(228,228,231)', fontWeight: '600', fontSize: '1.5rem', margin: 0}}>
            Subscription Details
        </h2>
        <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', marginTop: '.5rem'}}>
            Our service is priced at $40 USD per month. The subscription includes:
        </p>
        <div style={{margin: '1rem 0'}}>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', marginTop: '.25rem'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    Full access to Interview Cheater software
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    Automatic updates and new features
                </p>
            </div>
            {/* Bulleted List Item */}
            <div style={{display: 'flex', alignItems: 'center', gap: '.75rem', margin: '.75rem 0'}}>
                {/* Bullet point */}
                <div style={{background: '#e5e7eb', borderRadius: '50%', width: '.375rem', height: '.375rem'}}></div>
                {/* Text */}
                <p style={{color: 'rgb(212,212,216)', fontSize: '.875rem', lineHeight: '1.25rem', margin: '0'}}>
                    Customer support
                </p>
            </div>
        </div>
    </div>
    );
  }
  
  export default Subscription_Details;
  